const WA = "905303809300";
export const wa = (msg) => `https://wa.me/${WA}?text=${encodeURIComponent(msg)}`;

export const CONTACT = {
  whatsappDisplay: "0 530 380 93 00",
  whatsapp: `https://wa.me/${WA}`,
  telegramDisplay: "t.me/dolunaytv",
  telegram: "https://www.t.me/dolunaytv",
  instagramDisplay: "@dolunaytvmedya",
  instagram: "https://www.instagram.com/dolunaytvmedya",
};

export const TRIAL_LINK = wa("Merhaba, Dolunay TV 6 saatlik ücretsiz test talep etmek istiyorum.");

export const PACKAGES = [
  {
    id: "test",
    trial: true,
    tag: "Deneme",
    name: "Test Paketi",
    period: "6 Saat",
    price: "Ücretsiz",
    unit: "",
    coverage: "Satın almadan önce kaliteyi kendin gör",
    features: ["6 saat tam erişim", "Tüm içeriklere göz at", "Tüm cihazlarda dene", "Ödeme gerekmez"],
    cta: "Ücretsiz Test İste",
    link: TRIAL_LINK,
  },
  {
    flag: "tr",
    id: "turkiye",
    tag: "TR · AZ · KKTC",
    name: "Türkiye Elmas Paket",
    period: "12 Aylık",
    price: "1500",
    unit: "TL",
    coverage: "Türkiye, Azerbaycan ve K.K.T.C'de çalışır",
    features: ["500.000+ içerik", "Canlı TV, film ve dizi", "Android, iOS, Bilgisayar ve TV", "12 ay kesintisiz erişim"],
    cta: "WhatsApp ile Sipariş Ver",
    link: wa("Merhaba, 12 Aylık Türkiye Elmas Paket (1500 TL) sipariş vermek istiyorum."),
  },
  {
    id: "avrupa",
    tag: "Tüm Dünya",
    name: "Avrupa Elmas Paket",
    period: "12 Aylık",
    price: "65",
    unit: "€",
    coverage: "Tüm dünyada çalışır",
    features: ["500.000+ içerik", "Canlı TV, film ve dizi", "Android, iOS, Bilgisayar ve TV", "12 ay kesintisiz erişim"],
    cta: "WhatsApp ile Sipariş Ver",
    link: wa("Merhaba, 12 Aylık Avrupa Elmas Paket (65 Euro) sipariş vermek istiyorum."),
    featured: true,
    flag: "eu",
  },
];

export const CATEGORIES = [
  { id: "spor", title: "Spor", icon: "Trophy", img: "/img/stadium.jpg", channels: ["beIN SPORTS", "S Sport", "TRT Spor", "Tivibu Spor", "Exxen Spor", "Eurosport"] },
  { id: "film", title: "Film", icon: "Clapperboard", img: "/img/cinema.jpg", channels: ["beIN Movies", "Movie Smart", "Sinema TV", "FilmBox", "Dizi & Film VOD"] },
  { id: "dizi", title: "Dizi", icon: "Film", img: "/img/dizi.jpg", channels: ["TRT 1", "Show TV", "Kanal D", "ATV", "Star TV", "NOW"] },
  { id: "cocuk", title: "Çocuk", icon: "Baby", img: "/img/cocuk.jpg", channels: ["TRT Çocuk", "Cartoon Network", "Disney Channel", "Minika Çocuk", "Nickelodeon"] },
];

export const REVIEWS = [
  { name: "Mehmet K.", city: "İstanbul", text: "Derbiyi hiç donmadan, tertemiz görüntüyle izledik. Kurulum 5 dakika sürmedi, WhatsApp'tan anında yardım ettiler." },
  { name: "Ayşe D.", city: "Berlin", text: "Almanya'dan Türk kanallarını ve dizileri sorunsuz izliyorum. Avrupa paketi tam aradığım şeymiş, çocuklar da çizgi filmlere bayılıyor." },
  { name: "Emre T.", city: "Lefkoşa", text: "Önce 6 saatlik testi denedim, kaliteyi görünce hemen 12 aylık paketi aldım. Telefonda da TV'de de aynı hesapla giriyorum." },
];

export const WEB_PANEL = "http://musteripanelim.com.tr/main.php";

export const SETUP = [
  { id: "android", title: "Android Telefon", app: "Titan Android", url: "https://tinyurl.com/titanandoridapp", icon: "Smartphone",
    steps: ["“Uygulamayı indir” butonuna dokun ve Titan Android kurulum dosyasını indir.", "Telefon ayarlarında “bilinmeyen kaynaklardan yüklemeye” izin ver, indirdiğin dosyayı açıp kur.", "Uygulamayı aç, WhatsApp'tan gönderilen hesap bilgilerinle giriş yap ve izlemeye başla."] },
  { id: "ios", title: "iOS · iPhone & iPad", app: "Titan iOS", url: "https://tinyurl.com/titaniosapp", icon: "Apple",
    steps: ["“Uygulamayı indir” butonuna dokun, Titan iOS uygulama sayfası açılsın.", "Uygulamayı iPhone ya da iPad'ine yükle.", "Uygulamayı aç, WhatsApp'tan gönderilen hesap bilgilerinle giriş yap ve izlemeye başla."] },
  { id: "windows", title: "Windows Bilgisayar", app: "Titan Player", url: "http://tinyurl.com/titanplayerwindows", icon: "Monitor",
    steps: ["“Uygulamayı indir” butonuna tıkla ve Titan Player kurulum dosyasını bilgisayarına indir.", "İndirdiğin dosyayı çalıştır ve kurulumu tamamla.", "Programı aç, WhatsApp'tan gönderilen hesap bilgilerinle giriş yap ve izlemeye başla."] },
  { id: "box", title: "Android Box & TV", app: "Downloader", url: "https://play.google.com/store/apps/details?id=com.esaba.downloader&hl=tr", icon: "Tv",
    steps: ["TV'nde ya da Android Box'ında Google Play'den Downloader uygulamasını kur.", "Downloader'ı aç, kurulum kodunu WhatsApp'tan iste ve uygulamaya gir.", "İnen uygulamayı kur, hesap bilgilerinle giriş yap ve izlemeye başla."] },
];

export const FAQ = [
  { q: "Türkiye Elmas Paket hangi ülkelerde çalışır?", a: "Türkiye Elmas Paket Türkiye, Azerbaycan ve K.K.T.C'de çalışır. Bu bölgelerin dışındaysanız Avrupa Elmas Paket'i tercih edin." },
  { q: "Avrupa Elmas Paket nerede çalışır?", a: "Avrupa Elmas Paket tüm dünyada çalışır; nerede olursanız olun izleyebilirsiniz." },
  { q: "Hangi cihazlardan izleyebilirim?", a: "Android telefon, iPhone / iPad, Windows bilgisayar ve Android Box / Smart TV üzerinden giriş yapabilirsiniz. Kurulum bağlantıları Kurulum bölümünde." },
  { q: "Ücretsiz test nasıl alırım?", a: "“Ücretsiz Test İste” butonuna dokunun; WhatsApp üzerinden talebinizi iletin, 6 saatlik test hesabınız size gönderilsin." },
  { q: "Sipariş ve ödeme nasıl yapılıyor?", a: "Paketinizi seçip WhatsApp butonuna dokunun. Ödeme ve aktivasyon detayları WhatsApp üzerinden sizinle paylaşılır." },
];
